import { registerQuery, useQuery } from 'data-fetching-client';
import { HubsSettingClient } from 'frontend-preferences-client';
import { jsx as _jsx } from "react/jsx-runtime";
const hubsSettingClient = HubsSettingClient.forCaller('automation-ui-canvas');
export const SFDC_KEY = 'sfdc:v2-enabled';

/* PORTAL SETTINGS */

export const GET_SFDC_PORTAL_SETTINGS_QUERY = registerQuery({
  fieldName: 'portalSettings',
  args: [],
  fetcher() {
    return hubsSettingClient.fetch(SFDC_KEY, '').then(response => ({
      settings: [{
        hubId: 0,
        key: SFDC_KEY,
        value: response,
        internal: false
      }],
      hasMore: false
    }));
  }
});
export const wireSalesforceSettings = WrappedComponent => props => {
  const {
    data: salesforceSetting
  } = useQuery(GET_SFDC_PORTAL_SETTINGS_QUERY);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    salesforceSetting: salesforceSetting && salesforceSetting.portalSettings
  }));
};